export default __webpack_public_path__ + "163adab9dbd7cb1ed12a03407c74c489.ttf";